import { useTranslation } from "react-i18next";
import "./SkipLink.css";

export default function SkipLink({ targetId = "main-content" }) {
  const { t } = useTranslation("common");
  return (
    <a className="skip-link" href={`#${targetId}`}>
      {t("a11y.skipToContent")}
    </a>
  );
}
